import { render } from "./TitleH3.vue?vue&type=template&id=59ba9dfa&scoped=true"
import script from "./TitleH3.vue?vue&type=script&lang=js"
export * from "./TitleH3.vue?vue&type=script&lang=js"

import "./TitleH3.vue?vue&type=style&index=0&id=59ba9dfa&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ba9dfa"]])

export default __exports__